import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import NewCalendarHeader from './NewCalendarHeader';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReduxNewCalender from '../../../../store/actionreducers/new-calendar';
import {withRouter} from 'react-router-dom';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { LinearProgress } from '@material-ui/core'
import { checkIsAdminMedical } from "../../../../helper/mission";

moment.locale('zh-tw');
const localizer = BigCalendar.momentLocalizer(moment);

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 600,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            [theme.breakpoints.down('sm')]: {
                padding: 16
            },
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                ...theme.mixins.border(1)
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 135
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 4,
            padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        }
    },
    addButton: {
        position: 'absolute',
        right: 12,
        top: 172,
        zIndex: 99
    }
});

const weekDayMap = {Sun: '日', Mon: '一', Tue: '二', Wed: '三', Thu: '四', Fri: '五', Sat: '六'};

let monthCustomHeader = ({label}) => (
    <div>{weekDayMap[label]}</div>
);

const levels = [
    {level: 1, type: '一線', allDay: false, key: 'normal'},
    {level: 2, type: '總值', allDay: true, key: 'leader'},
    {level: 3, type: '救火', allDay: true, key: 'firefighter'},
];

const shortenName = name => {
    const head = name.slice(0, 2)
    const tail = name.slice(-2)

    return name.length > 4
        ? `${head}...${tail}`
        : name
}

class NewCalendarApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            events: [],
        };
    }

    async _updateEvents() {
        this.setState({ isLoading: true })
        const { date, fetchEventsMonthly, user } = this.props;
        const monthlyEvents = await fetchEventsMonthly(date);
        const isAdminMedical = checkIsAdminMedical(user)
        let index = 0;
        const events = [];
        Object.keys(monthlyEvents).forEach(eventDate => {
            if (!monthlyEvents.hasOwnProperty(eventDate)) return;

            levels.forEach(level => {
                const dailyEvents = monthlyEvents[eventDate][level.key];
                if (!dailyEvents.events.length) return;

                let medicalNames = []
                if (level.level === 1) {
                    const periods = { one: false, two: false, three: false, four: false, five: false, six: false};
                    dailyEvents.events
                        .filter(event => {
                            if (!isAdminMedical) return true
                            const institutionOfUser = user && user.medical && user.medical.fk_institution_id || ''
                            const institutionOfWorkEvent = event && event.medical && event.medical.fk_institution_id || ''
                            return institutionOfUser === institutionOfWorkEvent
                        })
                        .forEach(event => {
                        const periodKey = event.time_period.label;
                        periods[periodKey] = true;
                        if (event && event.medical && event.medical.user)
                            medicalNames.push(shortenName(event.medical.user.name))
                    });
                }

                const uniqueMedicalNames = medicalNames.filter((value, index, self) => {
                    return self.indexOf(value) === index
                })

                if (uniqueMedicalNames.length > 0) {
                    events.push({
                        id: ++index,
                        title: uniqueMedicalNames.join(', '),
                        allDay: level.allDay,
                        start: moment(eventDate).startOf('date').toDate(),
                        end: moment(eventDate).endOf('date').toDate(),
                        level: level.level,
                    })
                }
            });
        });
        this.setState({ isLoading: false, events })
    }

    async componentDidMount() {
        await this._updateEvents();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.date !== this.props.date) await this._updateEvents();
    }

    _onDateClick(event) {
        this.setState({ isLoading: true })
        const date = moment(event.start).format('YYYY-MM-DD');
        this.props.history.push({
            pathname: `/apps/new-calendar/${date}`,
            state: {redirectUrl: this.props.location.pathname}
        });
        this.setState({ isLoading: false })
    }

    render() {
        const {classes, date} = this.props;

        return (
            <div className={classes.root}>
                <div style={{ width: '100%' }}>
                    <LinearProgress
                        color="secondary"
                        style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                    />
                    <BigCalendar
                        className="flex flex-1"
                        selectable
                        localizer={localizer}
                        events={this.state.events}
                        resizable
                        defaultView={BigCalendar.Views.MONTH}
                        date={moment({ ...date }).toDate()}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month']}
                        step={60 * 4}
                        timeslots={1}
                        showMultiDayTimes
                        components={{
                            toolbar: props => <NewCalendarHeader {...props} reload={() => this._updateEvents()} />,
                            month: { header: monthCustomHeader, event: ({ event }) => {
                                    return <div style={{ whiteSpace: 'normal' }}>
                                        {event.title}
                                    </div>
                                } },
                        }}
                        onSelectEvent={event => this._onDateClick(event)}
                        onSelectSlot={slotInfo => this._onDateClick(slotInfo)}
                        eventPropGetter={(event) => {
                            return {
                                className: '',
                                style: {
                                    backgroundColor: 'transparent',
                                    color: 'black',
                                    fontSize: 12,
                                    display: 'block',
                                    marginTop: 0,
                                },
                            }
                        }}
                    />
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchEventsMonthly: ReduxNewCalender.ActionCreator.fetchEventsMonthly,
        setCalendarDate: ReduxNewCalender.ActionCreator.setCalendarDate,
    }, dispatch);
}

function mapStateToProps({newCalendarApp, auth: { user }}) {
    return {
        date: newCalendarApp.date,
        user,
    };
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCalendarApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/NewCalendarApp.js